export default "__VITE_ASSET__eBwUzLFp__"